define([
	"./_Flip",
	"./PluginFactory"
], function(_Flip, PluginFactory) {

	return PluginFactory.declare(_Flip, {
		degrees: 90,
		iconClass: "flipIcon",
		materialIcon: "rotate_90_degrees_ccw",
		pluginName: "rotate90CW",
		title: "CanvasRotate90CW"
	});
});
